import { Link, useParams } from 'react-router'
import Table from '../Components/AdminTable.js'
import { useEffect, useState } from 'react'
import { call } from '../Methods.js'
import { use } from '../Helpers.js'
import FormModal from '../Components/FormModal.js'

function Candidates () {
  const pageName = 'candidates'
  const pageTitle = 'Namizədlər'
  const [updateTable, setUpdateTable] = useState(false)
  const params = useParams()



  useEffect(() => {
    if (updateTable) {
      setUpdateTable(false)
    }
  }, [updateTable])

  useEffect(()=>{
    setUpdateTable(true);
    document.title = `${pageTitle} | ${process.env.REACT_APP_NAME}`
  },[params])

  const tableSettings = {
    name: '',
    label: '',
    filters: true,
    pagination: true,
    editLink: rowData => `/${pageName}/${rowData.id}`,
    actions: {
      get: async (params = {}) => {
        const result = await call.forLoggedUser.candidate.getCandidates(params)
        if (result.success) {
          return result.data
        }
        return []
      }
    },
    columns: [
      {
        title: '#',
        property: 'rowNumber',
        style: { width: '30px' },
        filter: {
          enabled: false
        }
      },
      {
        title: 'Adı və Soyadı',
        property: ['name', 'surname'],
        style: { width: '30%' },
        filter: {
          enabled: true,
          type: 'text',
          name: 'name'
        },
        mutate: values => {
          return values[0] + ' ' + values[1]
        }
      },
      {
        title: 'Filial',
        property: ['branchCode', 'branchName'],
        mutate: values => <span title={values[1]}>{values[0]}</span>,
        filter: {
          enabled: true,
          type: 'select',
          name: 'branchId',
          dataSource: async () => {
            const source = await call.forLoggedUser.branch.getBranches({})
            let data = source.data.map(d => {
              return { value: d.id, text: d.name }
            })
            return data
          }
        },
        style: { width: '10%' }
      },
      {
        title: 'Müraciətçi',
        property: 'requesterFullName',
        style: { width: '25%' },
        filter: {
          enabled: true,
          type: 'text',
          name: 'requesterFullName'
        }
      },
      {
        title: 'Depozit',
        property: 'depositAmount',
        type: 'number',
        style: { width: '10%' },
        filter: {
          enabled: false,
          type: 'number',
          name: 'depositAmount'
        },
        mutate: value => {
          return `${+value} ₼`
        }
      },
      {
        title: 'Status',
        property: 'statusName',
        type: 'status-label',
        style: { width: '10%' },
        filter: {
          enabled: true,
          type: 'select',
          name: 'statusId',
          dataSource: async () => {
            const source = await call.forLoggedUser.status.getStatuses({
              type: 'candidate'
            })
            let data = source.data.map(d => {
              return { value: d.id, text: d.description }
            })
            return data
          }
        },
        mutate: value => {
          return value
        }
      },
      {
        title: 'Əməliyyat',
        property: ['id'],
        type: 'operations-list',
        operations: values => [
          {
            type: 'group',
            name: 'menu',
            title: 'Group',
            icon: '...',
            items: [
              {
                type: 'command',
                name: 'candidateAddToGroup',
                title: 'Qrupa əlavə et',
                parameters: JSON.stringify({id:values[0]}),
                iconType: 'path',
                icon: '/Images/Icons/menu-icons/group.svg',
                iconStyle: { filter: 'invert(1)' },
                disablingConditions: []
              },
              {
                type: 'command',
                name: 'addDeposit',
                title: 'Depozit',
                parameters: JSON.stringify({id:values[0]}),
                disablingConditions: []
              },
              {
                type: 'command',
                name: 'delete',
                title: 'Qeydi sil',
                warning: `Namizədə aid bütün məlumatlar, o cümlədən, \n - Depozit ödənişləri\n - İmtahanlar iştirak\n məlumatları birdəfəlik silinəcək.`,
                parameters: JSON.stringify({id:values[0],entity:'candidate'}),
                iconType: 'path',
                icon: '/Images/Icons/delete.png',
                disablingConditions: []
              }
            ]
          }
        ],
        style: { width: '5%', minWidth: '50px' }
      }
    ],
    addNew: {
      enabled: true,
      url: `/${pageName}/add`,
      title: '+ Əlavə et'
    }
  }

  const formSettings = [
    {
      name: 'candidate',
      label: 'Namizəd',
      isStandAlone: true,
      isMain: true,
      id: '',
      actions: {
        get: id => call.forLoggedUser.candidate.getCandidateById({ id: id }),
        add: call.forLoggedUser.candidate.addCandidate,
        edit: call.forLoggedUser.candidate.updateCandidate
      },
      formLists: {
        Branches: async () => {
          const source = await call.forLoggedUser.branch.getBranches({})
          let data = source.data.map(d => {
            return {
              value: d.id,
              text: d.name
            }
          })
          return data
        },
        Courses: async () => {
          const source = await call.forLoggedUser.course.getCourses({})
          let data = source.data.map(d => {
            return {
              value: d.id,
              text: d.name
            }
          })
          return data
        },
        Genders: async () => {
          const source = await call.forLoggedUser.listOption.getListOptions({
            listName: 'Gender'
          })
          let data = source.data.map(d => {
            return { value: d.value, text: d.text }
          })
          return data
        },
        Requests: async () => {
          const source = await call.forLoggedUser.request.getRequests({})
          let data = source.data.map(d => {
            return {
              value: d.id,
              text: `${use.convertDatetimeToShortDate(d.requestDate)} ${
                d.requesterFullName
              }`
            }
          })
          return data
        },
        Statuses: async () => {
          const source = await call.forLoggedUser.status.getStatuses({
            type: 'candidate'
          })
          let data = source.data.map(d => {
            return { value: d.id, text: d.description }
          })
          return data
        }
      },
      fields: [
        { type: 'hidden', fieldName: 'id', label: '' },
        {
          label: 'Adı',
          fieldName: 'name',
          validationRules: ['required'],
          col: { sm: 2 }
        },
        {
          label: 'Soyadı',
          fieldName: 'surname',
          validationRules: ['required'],
          col: { sm: 3 }
        },
        {
          label: 'Müraciət tarixi',
          type: 'date',
          fieldName: 'registrationDate',
          validationRules: ['required'],
          col: { sm: 2 },
          mutate: value => {
            return use.isNullorEmpty(value)
              ? new Date().toLocaleDateString('AZ-az')
              : new Date(value).toLocaleDateString('AZ-az')
          }
        },
        {
          label: 'Filial',
          type: 'select',
          fieldName: 'branchId',
          col: { sm: 2 },
          acceptNullValue: false,
          data: 'Branches'
        },
        {
          label: 'Təlim',
          type: 'select',
          fieldName: 'requestCourseId',
          col: { sm: 3 },
          acceptNullValue: false,
          data: 'Courses'
        },
        {
          label: 'Cinsiyyəti',
          type: 'select',
          fieldName: 'gender',
          col: { sm: 1 },
          data: 'Genders'
        },
        {
          label: 'Doğum tarixi',
          type: 'date',
          fieldName: 'birthDate',
          col: { sm: 2 },
          mutate: value => {
            return use.isNullorEmpty(value)
              ? new Date('2010-01-01').toLocaleDateString('AZ-az')
              : new Date(value).toLocaleDateString('AZ-az')
          }
        },
        {
          label: 'Əlaqəli sorğu',
          type: 'select',
          fieldName: 'requestId',
          col: { sm: 3 },
          defaultSelectOptions: [{ value: '', text: 'Seçilməyib...' }],
          acceptNullValue: true,
          data: 'Requests'
        },
        {
          label: 'Telefon 1',
          fieldName: 'phone1',
          validationRules: ['required'],
          col: { sm: 3 }
        },
        {
          label: 'Telefon 2',
          fieldName: 'phone2',
          col: { sm: 3 }
        },
        {
          label: 'Ünvan',
          fieldName: 'address',
          col: { sm: 6 }
        },
        {
          label: 'Əlavə qeydlər',
          type: 'textarea',
          fieldName: 'notes',
          col: { sm: 6 }
        },
        {
          label: 'Status',
          type: 'select',
          fieldName: 'statusId',
          defaultValue: 0,
          col: { sm: 3 },
          data: 'Statuses'
        },
        { type: 'submit', label: 'Təsdiq', col: { sm: 12 } }
      ]
    }
  ]

  return (
    <div className='page'>
      <h1 className='page-title'>{pageTitle}</h1>
      <Table tableSettings={tableSettings} updateTable={updateTable} />

      <FormModal
        moduleUrl={`/${pageName}`}
        formSettings={formSettings}
        onSubmit={() => setUpdateTable(true)}
      />
    </div>
  )
}

export default Candidates